import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { shippingService } from '../services/shipping.service';

export function useToggleShippingRateStatus() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (refId: string) => shippingService.toggleShippingRateStatus(refId),
    onSuccess: () => {
      toast.success(t('shipping.statusUpdated', { defaultValue: 'Shipping rate status updated' }));
      queryClient.invalidateQueries({ queryKey: ['shippingRates'] });
    },
    onError: (error) => {
      console.error('Failed to toggle shipping rate status:', error);
      toast.error(t('common.error', { defaultValue: 'An error occurred' }));
    },
  });
}
